import classNames from 'classnames'
import { InputHTMLAttributes, ReactNode } from 'react'
import styles from './ButtonRadio.module.css'

export interface ButtonRadioProps extends InputHTMLAttributes<HTMLInputElement> {
  icon: ReactNode
  text: string
}

export const ButtonRadio = ({ id, icon, className, text, ...props }: ButtonRadioProps) => {
  const cardClassName = classNames(styles.button, className)

  return (
    <label className={classNames(styles.container)}>
      <input type="radio" id={id} name={id} tabIndex={0} {...props} />
      <span className={cardClassName}>
        <span className={styles.icon}>{icon}</span>
        <span className={styles.text}>{text}</span>
      </span>
    </label>
  )
}
